import { render, staticRenderFns } from "./giftcard-list.vue?vue&type=template&id=f484404a&scoped=true&"
import script from "./giftcard-list.vue?vue&type=script&lang=js&"
export * from "./giftcard-list.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-list.vue?vue&type=style&index=0&id=f484404a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484404a",
  null
  
)

export default component.exports